import "./App.css";

import frontEnd from "./assets/front.png";
import backEnd from "./assets/backend.png";
import logo from "./assets/logo.png";
import design from "./assets/design.png";
import git from "./assets/git.svg";
import React, { Component } from "react";
import menu from "./assets/menu.svg";

import philosophy from "./assets/philosophy.jpg";
import math from "./assets/maths.jpg";

import Contact from "./inputs/ContactMe";

import {
	makeStyles,
	withStyles,
	ThemeProvider,
} from "@material-ui/core/styles";
const classnames = require("classnames");

const useStyles = makeStyles({});

class PersonalWeb extends Component {
	state = {
		maths: null,
		mathImage: null,
		philosophies: null,
		philosophyImage: null,

		more: "More",
		isClicked: false,
		isIconClicked: false,
		view: {
			display: "none",
		},
	};

	seeMore = () => {
		if (!this.state.isClicked) {
			this.setState({
				maths: "Mathematics",
				philosophies: "Philosophy",
				mathImage: math,
				philosophyImage: philosophy,
				isClicked: true,
				more: "Less",
			});
		} else {
			this.setState({
				maths: null,
				philosophies: null,
				mathImage: null,
				philosophyImage: null,
				isClicked: false,
				more: "More",
			});
		}
	};

	menuState = () => {
		if (!this.state.isIconClicked) {
			this.setState({
				isIconClicked: true,
				view: { display: "block" },
			});
		} else {
			this.setState({
				isIconClicked: false,
				view: { display: "none" },
			});
		}
	};
	onClick = () => {
		return classnames("html");
	};
	render() {
		const { maths, mathImage, philosophies, philosophyImage } = this.state;

		return (
			<ThemeProvider>
				<div className="App">
					<div className="section-one">
						<Header className="logo-header">
							<Images source={logo} className="logo" />
						</Header>
						<Header className="skills">
							<a href="#skills">Skills</a>
						</Header>
						<Header className="about-me">
							<a href="#about-me">About Me</a>
						</Header>
						<Header className="contact-me">
							<a href="#contact-me">Contact Me</a>
						</Header>

						<Header className="menu" onclick={this.menuState}>
							<Images source={menu} />
							<div className="displayDropdown" style={this.state.view}>
								<div>
									<a href="#skills">Skills</a>
								</div>
								<div>
									<a href="#about-me">About Me</a>
								</div>
								<div>
									<a href="#contact-me">Contact Me</a>
								</div>
							</div>
						</Header>
					</div>
					<div className="section-two">
						<div className="bg-image">
							<h1 className="typing">Web programmer and designer.</h1>
							<div className="more-talent">
								<div className="math-image">
									<Images className="math" source={mathImage} />
									<h2 className="math-header">{maths}</h2>
								</div>
								<div className="philosophy-image">
									<Images source={philosophyImage} className="philo" />
									<h2 className="phil-header">{philosophies}</h2>
								</div>
							</div>

							<Header className="see-more" onclick={this.seeMore}>
								{this.state.more}
							</Header>
						</div>
					</div>
					<div className="section-two-subone">
						<h1 id="skills">Skills</h1>
					</div>
					<div className="for-tab-and-desktop">
						<div className="section-three">
							<div className="section-three-left">
								<Images
									source={frontEnd}
									className="front-end"
									alternatie_text="front-ent-not-found"
								/>
								<p className="front">frontend</p>
							</div>
							<div className="section-three-right" onClick={this.onClick}>
								<h4 className="html" text="90%">
									HTML{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className="css" text="65%">
									CSS{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className="react" text="75%">
									React{" "}
									<div>
										<div></div>
									</div>
								</h4>
							</div>
						</div>
						<div className="section-four">
							<div className="section-four-left">
								<Images
									source={backEnd}
									className="back-end"
									alternatie_text="back-end-not-found"
								/>
								<p className="back">backend</p>
							</div>
							<div className="section-four-right" onClick={this.onClick}>
								<h4 className="node" text="70%">
									Node.js{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className="express" text="75%">
									Express.js{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className=""></h4>
							</div>
						</div>

						<div className="section-five">
							<div className="section-five-left">
								<Images
									source={design}
									className="design"
									alternatie_text="design image is not found"
								/>
								<p className="prototyping">design</p>
							</div>
							<div className="section-five-right" onClick={this.onClick}>
								<h4 className="ux" text="85%">
									UX{" "}
									<div>
										<div></div>
									</div>
								</h4>

								<h4 className="figma" text="90%">
									Figma{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className=""></h4>
							</div>
						</div>

						<div className="section-six">
							<div className="section-six-left">
								<Images
									source={git}
									className="git"
									alternatie_text="git image not found"
								/>
								<p className="github">git</p>
							</div>

							<div className="section-six-right" onClick={this.onClick}>
								<h4 className="git-hub" text="75%">
									git{" "}
									<div>
										<div></div>
									</div>
								</h4>
								<h4 className="none-git"></h4>
								<h4 className="not-git"></h4>
							</div>
						</div>
					</div>
					<div className="hobby"></div>
					<div className="section-seven">
						<div className="section-seven-header">
							<h1 id="about-me">About Me</h1>
						</div>

						<div className="section-seven-one">
							<div className="image-cover">
								<div className="about-image"></div>
							</div>

							<div className="about">
								<h4>
									I am a React developer, with more experience in real-world
									projects, designing different layouts, manipulating layouts,
									participating in different teamwork web projects, with nice
									communication skills.
								</h4>
							</div>
						</div>
					</div>

					<div className="section-eight">
						<div className="contact-header">
							<h1 id="contact-me">Contact Me</h1>
						</div>

						<div className="contact-footer">
							<Contact />
						</div>
						<div className="hr">
							{" "}
							<hr />
						</div>
						<div className="courses-taken">
							<div className="math-part">
								<h6>Mathematics</h6>

								<ul>
									<li>Calculous</li>
									<li>Discrete Mathematics</li>
									<li></li>
								</ul>
							</div>
							<div className="programming-part">
								<h6>Programming </h6>

								<ul>
									<li>Data Structure and Algorithms</li>
									<li>Java </li>
									<li></li>
								</ul>
							</div>
							<div className="t-skills">
								<h6>Technical Skills</h6>

								<ul>
									<li>Flutter</li>
									<li>ASP.NET</li>
									<li>React</li>
								</ul>
							</div>
						</div>
						<p>Copy right &copy; 2021 is reserved</p>
					</div>
				</div>
			</ThemeProvider>
		);
	}
}

const Header = ({ className, onclick, children, style }) => (
	<button type="button" className={className} onClick={onclick} style={style}>
		{children}
	</button>
);

const Images = ({ className, source, alternatie_text }) => (
	<img src={source} className={className} alt={alternatie_text} />
);

export default withStyles(useStyles, { withTheme: true })(PersonalWeb);
